import { ContentInstitutionSearchOrder } from '@/data/usecases/content/content-institution-search-order'
import { Pagination } from '@/domain/models'
import { UserContentInstitutionSearchModel } from '@/domain/models/content/user-content-institution-search-model'

export interface UserContentInstitutionSearch {
  search(params: UserContentInstitutionSearch.Params): Promise<UserContentInstitutionSearch.Model>
  loader(params: UserContentInstitutionSearch.Params): Promise<UserContentInstitutionSearch.Model>
}

export namespace UserContentInstitutionSearch {
  export const INSTITUTION_NAME_PARAM_NAME = 'name'
  export const ORDER_PARAM_NAME = 'order'
  export const DEFAULT_PAGE_SIZE = 24
  export const Key = 'user-content-institution-search'

  export type Model = UserContentInstitutionSearchModel
  export interface Params extends Pagination.Params {
    name?: string | null
    order?: ContentInstitutionSearchOrder.Enum | null
  }
}
